import Cookies from 'js-cookie';
import { UserModel } from '@app/domain/UserModel';

// export const persistToken = (token: string): void => {
//     localStorage.setItem('accessToken', token);
//   };

export const readToken = (): string => {
  return Cookies.get('accessToken') || '';
};

export const readRefreshToken = (): string => {
  return Cookies.get('refreshToken') || '';
};

export const persistToken = (token: string): void => {
  Cookies.set('accessToken', token);
};

export const persistRefreshToken = (token: string): void => {
  Cookies.set('refreshToken', token);
};

export const readUser = (): UserModel | null => {
  const userStr = Cookies.get('user');

  return userStr ? JSON.parse(userStr) : null;
};

export const persistUser = (user: UserModel): void => {
  Cookies.set('user', JSON.stringify(user));
};

export const deleteAllCookies = (): void => {
  const cookies = Cookies.get();
  Object.keys(cookies).forEach((cookie) => {
    Cookies.remove(cookie, { path: '/' });
    Cookies.remove(cookie, { path: '/', domain: window.location.hostname });
  });
};
